var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    fill: "#363636"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report",
    clipPath: "url(#clip0_416_26311)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 2803,
    transform: "translate(-334 -1985)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002271"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6115",
    x: -334,
    y: -542,
    width: 375,
    height: 1277,
    fill: "#EFF0F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6116"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_416_26311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-334 -542H41V785H-334V-542Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-334 -542H41V785H-334V-542Z",
    fill: "#F7F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-334 -541.4H41V-542.6H-334V-541.4Z",
    fill: "#D9DBE9",
    mask: "url(#path-2-inside-1_416_26311)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 43129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5871",
    filter: "url(#filter0_d_416_26311)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -313,
    y: -67,
    width: 333,
    height: 157,
    rx: 4.80709,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -312.76,
    y: -66.7596,
    width: 332.519,
    height: 156.519,
    rx: 4.56674,
    stroke: "#E7E8F1",
    strokeWidth: 0.480709
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 134",
    d: "M8 4L0 4L4 4.76995e-08L8 4Z",
    fill: "#3C8DCB"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_416_26311",
    x: -327.421,
    y: -79.4984,
    width: 361.843,
    height: 185.843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.92284
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.21064
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.051 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_26311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_26311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_26311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 2803,
    fill: "white",
    transform: "translate(-334 -1985)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.a190e6142385c491b2408959f4899787.svg";
export { ForwardRef as ReactComponent };